export enum BubbleVariant {
    New = 'New',
    Occasional = 'Occasional',
    Consistent = 'Consistent',
    Decreasing = 'Decreasing',
    Inactive = 'Inactive',
}
